import React from 'react';
import './sec1-booking.css'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Cta from '../components/common/cta';
import { useNavigate } from 'react-router-dom';
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import './sec1-booking2.css'
import { useLocation } from 'react-router-dom';
import SecCta from '../components/common/secondarycta';


const Sec1bookingp2 = () => {


 const location = useLocation();
const bookingData = location.state;


const price = bookingData.ticket?.price || 0;
const subtotal = price * bookingData.quantity;
const taxes = 200;
const total = subtotal + taxes;




 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);







const navigate = useNavigate();


const handleBooking = async () => {
   

 const { data: userData, error: userError } = await supabase
    .from("users")
    .insert([{
      user_name: bookingData.user.name,
        user_email: bookingData.user.email,
      phone: bookingData.user.phone,
        job_title: bookingData.user.job_title,
      company_name: bookingData.user.company_name,
      address: bookingData.user.address,
    }])

    .select()
    .single();


  if (userError) {
    console.error(userError);
    alert("Error");
    return; 
  }

 const { error: bookingError } = await supabase
    .from("bookings")
    .insert([{
      user_id: userData.id,
      ticket_id: bookingData.ticket.id,
         booking_date: bookingData.date,

      quantity: bookingData.quantity,
      total_price: total,
      status: "pending"
    }]);


    
        if (bookingError) {
    console.error(bookingError);
    alert("Error creating booking");
    return; 
  }

}




    return (  
    <section  className='sec1-booking '>
            <h1 className='header-section'>{content?.[31]?.header}</h1>
            <nav className='container-booking-points'>
                <nav className='line-points-booking'>
                    <button className='normal-circle' onClick={() => navigate('/booking', { state: bookingData })}></button>       
                    <button className='activecircle'></button>                                                                  
                    <button className='normal-circle' onClick={() => navigate('/booking-card-pay', { state: bookingData })}></button>
                </nav>
            </nav>


            <fieldset className='container-forms-booking'>


                                    <section className='form-booking'>
                                        <section className='box1-sec5-p3'>
                                                 <article className='form-right-part-sec5-p3'>
                                                    <h2 className='subheadr-booking'>{content?.[31]?.sub_title}</h2>
                                                    <article className='sub-container-rightpart-sec5-p3'>
                                                        <h2 className='name-right-part-sec5-p2'>{bookingData.user.name || "Your Name"}</h2>
                                                        <h2 className='email-right-part-sec5-p2'>{bookingData.user.email || "Your Email"}</h2>
                                                        <h2 className='email-right-part-sec5-p2'>{bookingData.user.phone || "Your Phone"}</h2>
                                                    </article>

                                                    <div className='line-sec5-p2'></div>

                                                    <article className='sub-container-rightpart-sec5-p3'>
                                                        <article className='iconplustext-sec5-p2'>
                                                            <img src={pic30} alt='ticket'></img>
                                                            <h2 className='midd-text-right-part-sec5-p3'> {bookingData.quantity} {bookingData.ticket?.subheader }</h2>
                                                        </article>
                                                        <article className='iconplustext-sec5-p2'>
                                                            <img src={pic31} alt='date'></img>
                                                            <h2 className='midd-text-right-part-sec5-p3'>{new Date(bookingData.date).toDateString()}</h2>
                                                        </article>
                                                    </article>

                                                    <div className='line-sec5-p2'></div>

                                                    <article className='sub-container-rightpart-sec5-p3'>
                                                        <article className='subtotal-container-sec5-p2'>
                                                            <h2 className='subtotal-text-sec5-p3'>Subtotal</h2>
                                                            <h2 className='numberrr-text-sec5-p3'>{subtotal}EGP</h2>
                                                        </article>
                                                        <article className='subtotal-container-sec5-p2'>
                                                            <h2 className='subtotal-text-sec5-p3'>Taxes</h2>
                                                            <h2 className='numberrr-text-sec5-p3'>{taxes} EGP</h2>
                                                        </article>
                                                    </article>

                                                     <div className='line-sec5-p2'></div>                                                   

                                                    <article className='sub-container-rightpart-sec5-p3'>
                                                        <article className='subtotal-container-sec5-p2'>
                                                            <h2 className='subtotal-text-sec5-p3'>Total</h2>
                                                            <h2 className='totalnumberrcost'>{total} EGP</h2>
                                                        </article>
                                                    </article>


                                                 </article>
                                        </section>
                                    </section>


            </fieldset>

            <button className='CONTAINER-CTAA-BOOKING-PAGE2'>
                         <SecCta title={content?.[31]?.cta} onClick={() => navigate('/booking', { state: bookingData })}></SecCta>
                        <Cta title={content?.[31]?.cta2} onClick={() => navigate('/booking-card-pay', { state: bookingData })} />
            </button>

    </section>);
}
 
export default Sec1bookingp2;